import { createSelector } from 'reselect';
import metaSelector from 'Selectors/metaSelector';

const searchResultSelector = state => state.searchresult;

export default createSelector(
	[searchResultSelector, metaSelector],
	(searchresult, meta) => {
		return {
			searchresult: searchresult,
			meta: meta
		};
	}
);




// WEBPACK FOOTER //
// ./src/selectors/searchResultSelector.js